import { Component, ElementRef, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService, TaskInfoService } from '@rubicon/utils';
import { LocationStrategy } from '@angular/common';
import { NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { appConfig, appMetaTenant } from './+state/app.actions';
import { take } from 'rxjs/operators';
import { TagLoaderService, WorkflowActionsService } from '@platform-core/libraries/core-utils/ui-kit';
import { InactivityService } from '@platform-core/libraries/core-utils/ui-kit';
// eslint-disable-next-line no-var
declare const $: any;
@Component({
  selector: 'biz2x-pro-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  @HostListener('window:keydown', ['$event']) handleKeyDown(
    event: KeyboardEvent
  ) {
    if (event.keyCode == 9) {
      $('body').addClass('onFocus');
    } else {
      $('body').removeClass('onFocus');
    }
  }
  @HostListener('window:click', ['$event']) handleclick() {
    $('body').removeClass('onFocus');
  }
  constructor(
    private renderer: Renderer2,
    public taskInfoService: TaskInfoService,
    translate: TranslateService,
    public store: Store,
    private common: CommonService,
    private locationStrategy: LocationStrategy,
    public workflowActionsService: WorkflowActionsService,
    private titleService: Title,
    private _elementRef: ElementRef,
    @Inject('CONSTANTS') public CONSTANTS,
    private tagLoaderService: TagLoaderService,
    private inactivityService: InactivityService,
    @Inject('env') public env
  ) {
    this.titleService.setTitle(CONSTANTS.CLIENT_CONFIG.title);
    this.tagLoaderService.loanInitialTags(this.renderer);
    this.common.routerEvent.subscribe((val) => {
      if (val instanceof NavigationEnd) window.scroll(0, 0);
    });
    // check if back or forward button is pressed.
    this.locationStrategy.onPopState(() => {
      // set isBackButtonClicked to true.
      this.common.isBackButtonClicked = true;
      return false;
    });
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.workflowActionsService.setWorkflowActions().subscribe();
    this._elementRef.nativeElement.removeAttribute("ng-version");
    this.favIcon.href = this.env.asset_path+"favicon.ico"
    if (this.env?.config_from_api) {
      this.getConfiguration();
      this.getMetadataTenant();
    } else {
      this.store
        .select((state: any) => state?.app?.configurations)
        .pipe(take(1))
        .subscribe((res) => {
          if (!res) {
            this.getConfiguration();
          }
        });

      this.store
        .select((state: any) => state?.app?.meta_tenant)
        .pipe(take(1))
        .subscribe((meta_tenant) => {
          if (!meta_tenant) {
            this.getMetadataTenant();
          }
        });
    }
  }

  getConfiguration() {
    this.taskInfoService
      .getTaskInfo({ slug: this.CONSTANTS.SLUG.configuration })
      .subscribe((response) => {
        const configurations =
          response?.response_data?.get_configuration?.data?.data;
        this.store.dispatch(appConfig({ configurations }));
      });
  }

  getMetadataTenant() {
    this.taskInfoService
      .getTaskInfo({ slug: this.CONSTANTS.SLUG['get-metadata-tenant'] })
      .subscribe((res) => {
        const meta_tenant =
          res?.response_data?.['get-metadata-tenant']?.data?.data?.env_data;
        this.store.dispatch(appMetaTenant({ meta_tenant }));
      });
  }
}
